module.exports = __webpack_public_path__ + "img/logo.7ae3e52b.png";